import { stringify } from 'flatted';

export function transformLogObject({ logMessage, logObject, level }) {
  // This transformation is required to ensure that circular references in log objects do not cause issues when logging.
  return stringify({
    component: 'CX',
    text: logMessage,
    objects: logObject ? [logObject] : [],
    level: level.toUpperCase(),
  });
}
